import { render, staticRenderFns } from "./d2-container-card-bs.vue?vue&type=template&id=60d20c0c&"
import script from "./d2-container-card-bs.vue?vue&type=script&lang=js&"
export * from "./d2-container-card-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./d2-container-card-bs.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports